export default "__VITE_ASSET__BmaNESO8__"